module.exports = {
  async getSpot(spotId) {
    const url = `${this.url}/${this.version}/spots/${spotId}`;
    const response = await this.get(url, null, this.buildSessionHeaders());
    return response.data;
  },
};



// WEBPACK FOOTER //
// ./src/libs/api_client/modules/spots_api.js